import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type SocietyReportAccessParamsInput } from "shared/api/types/society/[societyId]/reports/access";
import { type ReportAccessSummary } from "shared/report-access/reportAccessTypes";
export const getSocietyReportsAccessContract: BaseApiContract<
  SocietyReportAccessParamsInput,
  undefined,
  ReportAccessSummary
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/reports/access",
  paramsType: {} as SocietyReportAccessParamsInput,
  responseType: {} as ReportAccessSummary,
};
